module.exports = __webpack_public_path__ + "static/media/home-care-card-1.0e8b7ba1.png";